import React from 'react';
import { deriveLinkButtonClasses } from '@farmers-fridge/ui-library';
import FFLink from '../FFLink';

/**
 * Need to do this to take advantage of Gatsby <Link> component
 *
 * @param {object} props
 * @param {("primary"| "secondary"| "tertiary")} props.buttonType
 * @param {React.ReactNode} props.children
 * @param {string=} props.className
 * @param {string} props.href
 * @param {React.MouseEventHandler=} props.onClick
 */
export default function FFLinkButton(props) {
  const { buttonType, ...validElementProps } = props;
  return (
    <FFLink
      {...validElementProps}
      // TODO: update FFLink accept prop "href" instead of "url"
      url={props.href}
      className={deriveLinkButtonClasses(props)}
    />
  );
}
